import { Routes } from "@angular/router";
import { ContentComponent } from "./shared/components/layout/content/content.component";
import { content } from "./shared/routes/routes";
import { LoginComponent } from "./auth/login/login.component";
import { AdminGuard } from "./shared/guard/admin.guard";
import { ForgotPasswordComponent } from "./auth/forgot-password/forgot-password.component";
import { RegisterComponent } from "./shared/components/layout/register/register.component";
import registerRoutes from "./components/register/register.routes";
import { NewPasswordComponent } from "./auth/new-password/new-password.component";
import { PageNotFoundComponent } from "./pages/page-not-found/page-not-found.component";
import { EventNotFoundComponent } from "./pages/event-not-found/event-not-found.component";
export const routes: Routes = [
  {
    path: "",
    redirectTo: "auth/login",
    pathMatch: "full",
  },
  {
    path: "auth/login",
    component: LoginComponent,
  },
  {
    path: "auth/reset-password",
    component: ForgotPasswordComponent,
  },
  {
    path: "auth/reset-password/new-password",
    component: NewPasswordComponent,
  },
  {
    path: "events/:token/participants/:tokenParticipant",
    component: RegisterComponent,
    children: registerRoutes,
  },
  {
    path: "admin",
    component: ContentComponent,
    children: [
      {
        path: "",
        redirectTo: "customers",
        pathMatch: "full",
      },
      ...content
    ],
    //canActivate: [AdminGuard], already setted for each subroute of /admin
  },
  {
    path: "event-not-found",
    component: EventNotFoundComponent,
  },
  {
    path: "**",
    component: PageNotFoundComponent,
  },
];
